export const GENERIC_ERROR = 'error.status.generic';
export const FUNCTION_NOT_IMPLEMENTED = 'error.status.function_not_implemented';
export const DENIED_REVOKE_AZIENDA = 'error.status.revoca_azienda';
export const DELETE_MULTI_ERROR = 'error.status.delete_multi';
export const DELETE_MULTI_NONE_ERROR = 'error.status.delete_multi_none';
export const DENIED_EDIT_DOCUMENT_NUMBER = 'error.status.edit_document_sent';
export const DENIED_EDIT_DOCUMENT_SENT_STATE =
  'error.status.edit_document_sent_state';
export const AUTOMATIC_DEADLINES_ERROR = 'error.status.automatic_deadline';
export const ERROR_REGISTER_SCADENZA_PRIMA_NOTA =
  'error.status.error_register_scadenza_prima_nota';
export const ERROR_ENABLE_RITENUTA =
  'error.status.error_enable_ritenuta_split_payment';
export const ERROR_ENABLE_SPLIT_PAYMENT_RITENUTA =
  'error.status.error_enable_split_payment_ritenuta';
export const ERROR_DISABLE_RITENUTA =
  'error.status.error_disable_ritenuta_payed_ritenuta';
export const ERROR_ENABLE_SPLIT_PAYMENT =
  'error.status.error_enable_split_payment';
export const FE_NOT_ACTIVE = 'error.status.fe_non_attivo';
export const MISSING_VAT = 'error.status.missing_vat';
export const MISSING_NAME = 'error.status.missing_name';
export const MISSING_VAT_AND_NAME = 'error.status.missing_vat_and_name';
export const DEMO_COMPANY = 'error.status.demo_company';
export const DEMO_COMPANY_NEW_TICKET = 'error.status.demo_company_new_ticket';
export const MASTER_ONLY = 'error.status.master_only';
export const SEDE_AMM_LOCKED = 'modal.error.sede_amministrativa_locked';
export const TAB_CANT_CLOSE = 'error.tab_cant_close';
export const CANT_MODIFY_BOLLO = 'modal.error.if_paid.cant_modify_bollo';
export const CANT_MODIFY_CASSE = 'modal.error.if_paid.cant_modify_casse';
export const CANT_MODIFY_RITENUTA = 'modal.error.if_paid.cant_modify_ritenuta';
export const CANT_MODIFY_ENASARCO = 'modal.error.if_paid.cant_modify_enasarco';
export const MISSING_VALUE_SCADENZA_PRIMA_NOTA =
  'error.status.missing_value_scadenza_prima_nota';
export const MISSING_VALUE_CONTO_SCADENZA_PRIMA_NOTA =
  'error.status.missing_value_conto_scadenza_prima_nota';
export const MISSING_VALUE_DATA_SCADENZA_PRIMA_NOTA =
  'error.status.missing_value_data_scadenza_prima_nota';
export const USED_ANAGRAFICA = 'error.status.used_anagrafica';
export const USED_ANAGRAFICA_SAVE = 'error.status.used_anagrafica_save';
export const USED_ANAGRAFICA_SHOW = 'error.status.used_anagrafica_show';
export const USED_ANAGRAFICA_SCHEDA = 'error.status.cant_open_anagrafica';
export const USED_PRIMA_NOTA_SHOW = 'error.status.used_prima_nota_show';
export const USED_MAGAZZINO = 'error.status.used_magazzino';
export const USED_MAGAZZINO_SAVE = 'error.status.used_magazzino_save';
export const USED_MAGAZZINO_SHOW = 'error.status.used_magazzino_show';
export const USED_ELEMENT = 'error.status.used_element';
export const USED_ELEMENT_DFVE = 'error.status.used_element_dfve';
export const USED_ELEMENT_SHOW_DOC = 'error.status.used_element_show_doc';
export const USED_ELEMENT_SAVE = 'error.status.used_element_save';
export const USED_ELEMENT_SHOW = 'error.status.used_element_show';
export const CANT_REGENERATE_IF_PAID = 'error.cant_regenerate_if_paid';
export const ALLEGATO_NOT_FETCHED = 'error.allegato_not_fetched_correctly';
export const GENERATE_XML_WHEN_SCADENZE_INCONGRUENTI =
  'error.status.generate_xml_when_scadenze_incongruenti';
export const SEND_XML_WHEN_SCADENZE_INCONGRUENTI =
  'error.status.send_xml_when_scadenze_incongruenti';
export const LOCKED_RECORD_MASSIVE_UPDATE =
  'error.locked_records_on_massive_update';
export const CANT_DUPLICATE_DOCUMENT_MAX_1500_ROWS =
  'error.cant_duplicate_document_max_1500_rows';
export const LIMIT_SELECTED_FIXED_NUMBER =
  'error.status.limit_selected_fixed_number';
export const NESSUNA_VARIAZIONE = 'error.status.nessuna_variazione';
export const ERROR_BARCODE = 'error.status.error_barcode';
export const ERRORS: Record<string | number, string> = {
  400: 'error.status.credentials_error',
  401: 'error.status.unauthorized',
  404: 'error.status.record_not_found',
  422: 'error.status.unprocessable_entity',
  423: 'error.status.record_locked',
  500: 'error.status.badrequest',
  502: 'error.status.network_error',
  503: 'error.status.maintenance',
  [GENERIC_ERROR]: 'error.status.generic',
  [FUNCTION_NOT_IMPLEMENTED]: 'error.status.function_not_implemented',
  [DELETE_MULTI_ERROR]: 'error.status.delete_multi',
  [DELETE_MULTI_NONE_ERROR]: 'error.status.delete_multi_none',
  [DENIED_REVOKE_AZIENDA]: 'error.status.revoca_azienda',
  [DENIED_EDIT_DOCUMENT_NUMBER]: 'error.status.edit_document_sent',
  [DENIED_EDIT_DOCUMENT_SENT_STATE]: 'error.status.edit_document_sent_state',
  [AUTOMATIC_DEADLINES_ERROR]: 'error.status.automatic_deadline',
  [ERROR_REGISTER_SCADENZA_PRIMA_NOTA]:
    'error.status.error_register_scadenza_prima_nota',
  [MISSING_VAT]: 'error.status.missing_vat',
  [MISSING_NAME]: 'error.status.missing_name',
  [MISSING_VAT_AND_NAME]: 'error.status.missing_vat_and_name',
  [ERROR_ENABLE_RITENUTA]: 'error.status.error_enable_ritenuta_split_payment',
  [ERROR_DISABLE_RITENUTA]:
    'error.status.error_disable_ritenuta_payed_ritenuta',
  [ERROR_ENABLE_SPLIT_PAYMENT]: 'error.status.error_enable_split_payment',
  [MISSING_VALUE_SCADENZA_PRIMA_NOTA]:
    'error.status.missing_value_scadenza_prima_nota',
  [MISSING_VALUE_CONTO_SCADENZA_PRIMA_NOTA]:
    'error.status.missing_value_conto_scadenza_prima_nota',
  [MISSING_VALUE_DATA_SCADENZA_PRIMA_NOTA]:
    'error.status.missing_value_data_scadenza_prima_nota',
  [FE_NOT_ACTIVE]: 'error.status.fe_non_attivo',
  [DEMO_COMPANY]: 'error.status.demo_company',
  [DEMO_COMPANY_NEW_TICKET]: 'error.status.demo_company_new_ticket',
  [MASTER_ONLY]: 'error.status.master_only',
  [SEDE_AMM_LOCKED]: 'modal.error.sede_amministrativa_locked',
  [CANT_MODIFY_BOLLO]: 'modal.error.if_paid.cant_modify_bollo',
  [CANT_MODIFY_CASSE]: 'modal.error.if_paid.cant_modify_casse',
  [CANT_MODIFY_RITENUTA]: 'modal.error.if_paid.cant_modify_ritenuta',
  [CANT_MODIFY_ENASARCO]: 'modal.error.if_paid.cant_modify_enasarco',
  [USED_ANAGRAFICA]: 'error.status.used_anagrafica',
  [USED_ANAGRAFICA_SAVE]: 'error.status.used_anagrafica_save',
  [USED_ANAGRAFICA_SHOW]: 'error.status.used_anagrafica_show',
  [USED_ANAGRAFICA_SCHEDA]: 'error.status.cant_open_anagrafica',
  [USED_MAGAZZINO]: 'error.status.used_magazzino',
  [USED_MAGAZZINO_SAVE]: 'error.status.used_magazzino_save',
  [USED_MAGAZZINO_SHOW]: 'error.status.used_magazzino_show',
  [USED_ELEMENT]: 'error.status.used_element',
  [USED_ELEMENT_SAVE]: 'error.status.used_element_save',
  [USED_ELEMENT_SHOW]: 'error.status.used_element_show',
  [TAB_CANT_CLOSE]: 'error.tab_cant_close',
  [ERROR_ENABLE_SPLIT_PAYMENT_RITENUTA]:
    'error.status.error_enable_split_payment_ritenuta',
  [CANT_REGENERATE_IF_PAID]: 'error.cant_regenerate_if_paid',
  [LOCKED_RECORD_MASSIVE_UPDATE]: 'error.locked_records_on_massive_update',
  [ALLEGATO_NOT_FETCHED]: 'error.allegato_not_fetched_correctly',
  [GENERATE_XML_WHEN_SCADENZE_INCONGRUENTI]:
    'error.status.generate_xml_when_scadenze_incongruenti',
  [SEND_XML_WHEN_SCADENZE_INCONGRUENTI]:
    'error.status.send_xml_when_scadenze_incongruenti',
  [USED_ELEMENT_DFVE]: 'error.status.used_element_dfve',
  [USED_ELEMENT_SHOW_DOC]: 'error.status.used_element_show_doc',
  [USED_PRIMA_NOTA_SHOW]: 'error.status.used_prima_nota_show',
  [LIMIT_SELECTED_FIXED_NUMBER]: 'error.status.limit_selected_fixed_number',
  [NESSUNA_VARIAZIONE]: 'error.status.nessuna_variazione',
};

export const ERRORS_FOR_ACTION: Record<string | number, string> = {
  ...ERRORS,
};
